module.exports = {
  methods: {
    getViewportSize: function() {
      var a, e;
      if (window.innerWidth != null) {
        e = window;
        a = 'inner';
      } else {
        a = 'client';
        e = document.documentElement || document.body;
      }
      return {
        width: e[a + 'Width'],
        height: e[a + 'Height']
      };
    }
  }
};



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri/lib/getViewportSize.js
// module id = 20
// module chunks = 1